import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"facebook\">\n<path d=\"M353.323 276.214L365.599 195.389H288.814V142.962C288.814 120.844 299.52 99.272 333.911 99.272H368.842V30.4612C368.842 30.4612 337.156 25 306.874 25C243.608 25 202.296 63.7197 202.296 133.787V195.389H132V276.214H202.296V471.616C216.409 473.852 230.847 475 245.555 475C260.263 475 274.7 473.852 288.814 471.616V276.214H353.323Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol